import { render, staticRenderFns } from "./FTotalCard.vue?vue&type=template&id=8e432d78&scoped=true&"
import script from "./FTotalCard.vue?vue&type=script&lang=js&"
export * from "./FTotalCard.vue?vue&type=script&lang=js&"
import style0 from "./FTotalCard.vue?vue&type=style&index=0&id=8e432d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e432d78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
